export const MISSION_LOCALE_SLUG = 'mission-locale'